<template>
    <div class="checkout-page">
        <!-- begin 弹层 -->
        <v-dialog v-model="errorDialog" width="500">
            <v-card>
                <v-card-title>
                    <span>{{ tip }}</span>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                        color="primary"
                        flat
                        @click="
              errorDialog = false;
              tip = '';
            "
                    >
                        {{ $t("common.close") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end 弹层 -->

        <!-- begin 下单成功弹层 -->
        <v-dialog v-model="orderDialog" max-width="290">
            <v-card>
                <v-card-title class="headline">{{
                        $t("checkout.tip_title")
                    }}
                </v-card-title>
                <v-card-text>
                    {{ $t("checkout.tip_content") }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="goToOrder">
                        {{ $t("checkout.tip_confrim") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end 下单成功弹层 -->

        <v-container>
            <!-- begin 已点菜品 -->
            <v-layout justify-center :column="breakpoint.mdAndDown">
                <v-flex class="your-order-container" xs6>
                    <div class="your-order-title">
                        {{ $t("checkout.your_order_title") }}
                    </div>
                    <table class="order-table">
                        <template v-for="(item, index) in cart.items">
                            <tr class="order-item" :key="`tr2_${index}`" style="border-bottom: none;">
                                <td>
                                    <img class="delivery_cover" v-if="item.delivery" :src="item.delivery.cover.url"/>
                                </td>
                                <td>
                                    <div @click="goToDetail(item.guid)" class="name-row" v-if="item.delivery">
                                        <div>
                                            {{
                                                (item.delivery.commodity_name_json &&
                                                    item.delivery.commodity_name_json[getTranslateIndex]) ||
                                                item.delivery.name
                                            }}
                                        </div>
                                        <div class="description">
                                            {{
                                                (item.delivery.description_json &&
                                                    item.delivery.description_json[getTranslateIndex]) ||
                                                item.delivery.description
                                            }}
                                        </div>
                                    </div>
                                    <!-- 菜品属性 -->
                                    <div class="attr-tag" v-if="item.delivery">
                                      <span
                                          v-for="(cate_item, cate_index) in (item.delivery.attributes_cate || [])"
                                          :key="cate_index"
                                      >
                                          <span v-for="(attr_item, index) in (cate_item.attributes || [])" :key="index">
                                              <span v-if="attr_item.check" style="padding-right: 6px;white-space: nowrap;">{{ attr_item.name }} <span v-if="attr_item.price && Number(attr_item.price)">€ {{ attr_item.price }}</span></span>
                                          </span>
                                      </span>
                                    </div>

                                    <!-- 套餐菜品 -->
                                    <div class="garnish-row"  v-if="item.delivery">
                                        <div
                                            v-for="(garnish_item, garnish_index) in item.delivery.garnish"
                                            :key="garnish_index"
                                        >
                                            <div
                                                v-for="(commodity_item,commodity_index) in garnish_item.commodity"
                                                :key="commodity_index"
                                            >
                                                <div
                                                    v-if="commodity_item.check && (item.garnish[garnish_index].commodity_guid === commodity_item.commodity_guid)"
                                                    class="commodity_name_row"
                                                >
                                                    <div>
                                                        {{
                                                            (commodity_item.commodity_name_json &&
                                                                commodity_item.commodity_name_json[getTranslateIndex]) ||
                                                            commodity_item.commodity_name
                                                        }}
                                                    </div>
                                                    <div style="white-space: nowrap">
                                                        {{ commodity_item.price }} €
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr :key="`tr1_${index}`">
                                <td style="font-size: 16px;white-space: nowrap;" v-if="item.delivery">
                                    {{
                                        (item.num * parseFloat(item.price_attr_total || item.price))
                                            | fixed(2, true)
                                    }}
                                    €
                                </td>
                                <td colspan="2" style="text-align: right;">
                                    <v-btn
                                        fab
                                        dark
                                        outline
                                        small
                                        color="primary"
                                        class="stepper"
                                        @click="handleMinusFromCart(item.guid, index)"
                                    >
                                        <v-icon dark>remove</v-icon>
                                    </v-btn>
                                    <strong class="num">{{ item.num }}</strong>
                                    <v-btn
                                        fab
                                        dark
                                        outline
                                        small
                                        color="primary"
                                        class="stepper"
                                        @click="handleAddToCart(item.guid, index)"
                                    >
                                        <v-icon dark>add</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </table>
                </v-flex>
            </v-layout>
            <!-- end 已点菜品 -->

            <!-- begin 小计 -->
            <div class="total-container">
                <div>{{ $t("checkout.subtotal") }}</div>
                <strong class="total-price"
                >{{
                        actuallyPaidAmount != 0
                            ? actuallyPaidAmount
                            : cartsInfo.actuallyPaidAmount
                    }}
                    €</strong
                >
            </div>
            <!-- end 小计 -->

            <!-- begin 备注 -->
            <div class="remark-container">
                <div>{{ $t("checkout.remark") }}</div>
                <textarea v-model="remark"/>
            </div>
            <!-- end 备注 -->

            <div class="footer-container">
                <button class="button shadow goon-button" @click="backHome">
                    {{ $t("checkout.continue") }}
                </button>

                <button
                    class="button shadow place-order-button"
                    @click="handleSubmit"
                    :disabled="!canSubmit"
                >
                    {{ $t("checkout.title") }}
                </button>
            </div>
        </v-container>

        <!--不允许用户下单提示-->
        <v-dialog v-model="noPlaceOrderPerModal" max-width="290">
            <v-card>
                <v-card-title class="headline">{{
                        $t("checkout.tip_title")
                    }}
                </v-card-title>
                <v-card-text>
                    {{ $t("checkout.no-place-order") }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="noPlaceOrderPerModal=false">
                        {{ $t("checkout.tip_confrim") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {mapState, mapGetters, mapMutations, mapActions} from "vuex";
import Qrcode from "../../../api/qrcode";
import {fixed} from "../../../utils";

export default {
    data() {
        return {
            paymentMethod: "",
            addressGuid: null,
            deliveryFee: {
                fee: 0
            },
            errorDialog: false,
            orderDialog: false,
            tip: "",
            total: 0,
            discount: 0,
            discountAmount: 0,
            actuallyPaidAmount: 0,
            noPlaceOrderPerModal: false,

            // 备注
            remark: sessionStorage.getItem('remark') || "",

            canSubmit: true
        };
    },
    mounted() {
        this.getStorePayment();
        this.getMyOrder();

        // 监听message事件，方法是后台定义和提供的
        this.sockets.subscribe(`message_${this.tableGuid}`, data => {
            if (!data) {
                this.resetCart([]);
            } else {
                let payload = JSON.parse(data).result.items.map(item => {
                    return {
                        ...item,
                        is_threshold: item.is_threshold ? 1 : 0,
                        num: item.quantity,
                        guid: item.commodityGuid,
                        attributes: item.attributes,
                        garnish: item.garnish
                    };
                });

                console.log("结算页 socket返回的数据");
                console.log(JSON.parse(data));

                this.resetCart(payload);
                this.actuallyPaidAmount = JSON.parse(data).result.actuallyPaidAmount;
            }
        });
    },

    created() {
        this.getQrcodeCart();
    },
    destroyed() {
        this.sockets.unsubscribe(`message_${this.tableGuid}`);
    },
    computed: {
        ...mapState([
            "storePayment",
            "storeInfo",
            "addressList",
            "storeId",
            "guid",
            "tableGuid",
            "cartsInfo",
            "isBuffet",
            "myOrder",
            "buffetRoundSetting"
        ]),
        ...mapGetters(["cart", "getTranslateIndex"]),
        checkedAddress() {
            return this.addressList.find(item => {
                return item.guid === this.addressGuid;
            });
        },
        breakpoint() {
            return this.$vuetify.breakpoint;
        }
    },
    methods: {
        ...mapMutations(["clearCart", "addToCart", "minusFromCart", "resetCart"]),
        ...mapActions(["getStorePayment", "updateQrcodeCart", "getQrcodeCart","getMyOrder"]),

        backHome() {
            this.$router.back();
        },
        async handleSubmit() {
            if (!this.storeInfo.storeConf || !this.storeInfo.storeConf.qrIfAllowOrder) {
                this.noPlaceOrderPerModal = true;
                return;
            }
            this.canSubmit = false;
            const payload = {
                tableGuid: this.tableGuid,
                items: this.cart.items.map(item => {
                    return {
                        commodityGuid: item.delivery.guid,
                        quantity: item.num,
                        price: item.price,
                        attributes: item.attributes,
                        garnish: item.garnish,
                        is_people: 0,
                        categoryGuid: item.delivery && item.delivery.categoryGuid,
                    };
                }),
                paymentMethod: this.paymentMethod,
                remarks: this.remark
            };

            try {
                if(this.isBuffet === 2){
                    let { data: { data } } = await Qrcode.loadMyOrder({
                        tableGuid: this.tableGuid
                    });
                    if(!data){
                        alert(this.$t("checkout.open-order"));
                        return ;
                    }
                }
                const {
                    data: {isError, msg}
                } = await Qrcode.createOrder(payload, this.isBuffet);

                sessionStorage.removeItem('remark');

                if (isError) {
                    this.tip = msg;
                    this.errorDialog = true;
                    return;
                }

                this.clearCart();
                this.orderDialog = true;
            } catch (e) {
                const {
                    response: {
                        data: {msg}
                    }
                } = e;

                this.errorDialog = true;
                this.tip = msg;
            } finally {
                this.canSubmit = true;
            }
        },

        handleMinusFromCart(guid, index) {
            this.minusFromCart({
                num: 1,
                guid,
                index
            });
            this.updateQrcodeCart();
        },
        handleAddToCart(guid, index) {
            const payload = {
                guid,
                num: 1,
                index
            };

            this.addToCart(payload);
            this.updateQrcodeCart();
        },

        goToOrder() {
            this.$router.push({
                name: "ordered",
                query: {
                    redirect: "table" // 提交后跳转到桌位列表
                }
            });
            this.orderDialog = false;
        },

        goToDetail(guid) {
            this.$router.push({
                name: "delivery/detail",
                params: {id: guid}
            });
        }
    },
    watch: {
        storePayment(value) {
            if (value.length < 0) {
                return;
            }

            const index = value.findIndex(item => {
                return item.systemName === this.paymentMethod;
            });

            if (index > -1) {
                return;
            }

            this.paymentMethod = value[0].systemName;
        },
        addressList(value) {
            if (value.length <= 0) {
                return;
            }

            const defaultAddress = value.find(item => {
                return item.defaultAddress;
            });

            this.addressGuid = defaultAddress.guid;
        },

        "cart.items"(items) {
            // 结算页清空的时候返回点餐页
            if (items.length == 0) {
                // this.$router.back();
            }
        },
        "remark"(value){
            sessionStorage.setItem('remark', value)
        }
    },
    filters: {
        fixed
    }
};
</script>

<style scoped lang="sass" src="./checkout.sass"></style>
